import { render, staticRenderFns } from "./EditCategoryForm.vue?vue&type=template&id=c1dda6e4&scoped=true&"
import script from "./EditCategoryForm.vue?vue&type=script&lang=js&"
export * from "./EditCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dda6e4",
  null
  
)

export default component.exports